import React, { Component } from 'react'
import SignaturePad from 'react-signature-canvas'
import { Button } from "reactstrap";

import styles from './styles.module.css'

class Signature extends Component {

  constructor(props) {
    super(props);
    this.state = {
      trimmedDataURL: null,
      signActive: false,
      signError: false,
      saving: false,
      saveError: false,
    }
    this.editApp = this.editApp.bind(this);
    this.signApp = this.signApp.bind(this);
    this.trim = this.trim.bind(this);
    this.close = this.close.bind(this);
  };

  sigPad = {}

  clear = () => {
    if (this.sigPad && this.sigPad.clear) {
      this.sigPad.clear()
    }
  }

  close = () => {
    this.clear()
    this.setState({
      signActive: false,
      signError: false,
      saveError: false,
    });
  }

  async trim() {
    if (this.state.saving) {
      return;
    }

    const lienId = this.props.data && this.props.data._id;
    if (!lienId) {
      this.setState({
        saveError: true,
        signError: false,
      });
      return;
    }

    const checkForSignature = this.sigPad.isEmpty();
    if (checkForSignature) {
      this.setState({
        signError: true,
        saveError: false,
      });
      return;
    }

    const signature_image = this.sigPad.getTrimmedCanvas().toDataURL('image/png').toString();
    this.setState({
      trimmedDataURL: signature_image,
      saving: true,
      signError: false,
      saveError: false,
    });

    const newData = {
      ...this.props.data,
      contractor_signature: signature_image,
      pm_signature: this.props.data.pm_signature || '',
      status: 'signed',
    };
    delete newData._id;

    try {
      const response = await fetch(
        "https://sanders-hyland-server.herokuapp.com/update-signature/" + lienId,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(newData),
        }
      );

      if (!response.ok) {
        throw new Error("Signature save failed with status " + response.status);
      }

      await response.json();

      this.setState({
        signActive: false,
        saving: false,
      });

      // Prefer in-place refresh so the page does not reset to "started"
      // and re-prompt for a signature.
      if (typeof this.props.onSigned === 'function') {
        this.props.onSigned({
          ...this.props.data,
          _id: lienId,
          contractor_signature: signature_image,
          status: 'signed',
        });
      } else if (typeof this.props.onRefresh === 'function') {
        this.props.onRefresh();
      }
    } catch (error) {
      console.error(error);
      this.setState({
        saving: false,
        saveError: true,
      });
    }
  }

  signApp() {
    if (!this.props.data || !this.props.data._id) {
      this.setState({
        saveError: true,
      });
      return;
    }
    this.setState({
      signActive: true,
      signError: false,
      saveError: false,
    });
  }

  editApp() {
    if (!this.props.data || !this.props.data._id) {
      return;
    }
    this.props.history.push('/lien-form/' + this.props.data._id)
  }

  render () {
    return <div>
    <div className={ this.state.signActive ? 'signature active' : 'signature' }>
      <div className="signatureInner">
          <div className={this.state.signError ? 'error active' : 'error'}>Please sign your name before you submit!</div>
          <div className={this.state.saveError ? 'error active' : 'error'}>Unable to save signature. Please wait for the application to finish loading and try again.</div>
        <div className="instructions">Sign Here (use your finger or mouse):</div>
        <div className={styles.container}>
          <div className={styles.sigContainer}>
          <SignaturePad canvasProps={{height: 200, width: 400, className: styles.sigPad}}
            ref={(ref) => { this.sigPad = ref }} />
          </div>
          <div>
            <button className={styles.buttons} onClick={this.clear} disabled={this.state.saving}>
              CLEAR
            </button>
            <button className={styles.buttons} onClick={this.close} disabled={this.state.saving}>
              CLOSE
            </button>
            <button className={styles.buttons} onClick={this.trim} disabled={this.state.saving}>
              {this.state.saving ? 'SAVING...' : 'SAVE'}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div className='status started'>
      <Button variant="warning" size="Lg" onClick={this.editApp}>EDIT</Button>
      <Button variant="success" size="Lg" onClick={this.signApp}>SIGN</Button>
    </div>

    </div>
  }
}

export default Signature;
